import React from 'react';
import styles from './modal.module.scss';

type ModalProps = {
  close(): void;
  children: React.ReactNode;
  popup?: boolean;
};

const Modal = ({ close, children, popup }: ModalProps) => (
  <div className={styles.modalBackdrop}>
    <div className={`${styles.modal} ${popup ? styles.popup : ''}`}>
      <a onClick={close} className={styles.closeModal}>&times;</a>
      {children}
    </div>
  </div>
);
export default Modal;
